<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Attachment from '../../../model/attachment.js';
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "المستندات",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading},
  data() {
    return {
      title: "تعديل المستند",
      items: [
        {
          text: "المستندات",
          href: "/attachments",
        },
        {
          text: "تعديل المستند",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      attachment: new Attachment,
      acceptFile: appConfig.acceptFile.attachment,
      submitadd: false,
      loadingButton: false,
      loadingContent: false     
    };
  },
  validations: {
    attachment: {
      title_ar: {required, minLength: minLength(2), maxLength: maxLength(300) },
    },
  },
  computed:{
    ...mapGetters('attachment', ['getAttachment'])
  },
  methods: {
    ...mapActions("attachment", ['get', 'edit']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    formEditAttachment() {
      this.submitadd = true;
      this.$v.$touch();
      if(this.$v.$error) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      
      this.edit({
        id: this.id,
        attachment: this.attachment.toFormData()
      }).then((response)=>{
        this.loadingButton = false
        swal.success(response.data.message)
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    },
    copyToClipboard() {
        var textBox = document.getElementById("url");
        textBox.select();
        navigator.clipboard.writeText(textBox.value)
    },
  },
  created(){
    this.get(this.id)
    .then(()=>{
      this.attachment = this.getAttachment
      this.loadingContent = true
    })
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <b-form v-if="loadingContent" @submit.prevent="formEditAttachment">
              
              <AlertError :errors="errors"></AlertError>


              <div class="row mt-3">
                <b-form-group class="col-md-12 mb-3" label="عنوان المستند : " label-for="title_ar" >
                  <b-form-input id="title_ar" v-model.trim="attachment.title_ar" :class="{ 'is-invalid': submitadd && $v.attachment.title_ar.$error }" placeholder="ادخل عنوان المستند" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.attachment.title_ar.$error" class="invalid-feedback">
                    <span v-if="!$v.attachment.title_ar.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.attachment.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.attachment.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>
                <b-form-group class="col-md-12 mb-3" label="رابط المستند : " label-for="url" >
                  <div class="input-group">
                    <b-form-input id="url" v-model="attachment.url" readonly placeholder="" type="text" ></b-form-input>
                    <button class="btn btn-primary" @click="copyToClipboard" type="button"> نسخ الرابط </button>
                  </div>
                </b-form-group>
                <b-form-group class="col-md-12 mb-3" label="وصف المستند : " label-for="description_ar" >
                  <textarea id="description_ar" v-model.trim="attachment.description_ar" class="form-control" rows="5" ></textarea>
                </b-form-group>
              </div>
              <div class="mt-3">
                <hr>
                <b-button :disabled="loadingButton" variant="primary" type="submit" class="me-2"> 
                  <b-spinner v-if="loadingButton" small></b-spinner>
                  <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
                </b-button>
                <router-link :to="{ name: 'attachments.index' }">
                  <b-button class="f-left" type="button" variant="secondary">رجوع</b-button>
                </router-link>
              </div>
            </b-form>
            
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="106">
                <rect x="0" y="5" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="9" rx="1" ry="1" width="400" height="10" />

                <rect x="0" y="24" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="28" rx="1" ry="1" width="380" height="10" />
                <rect x="381" y="28" rx="1" ry="1" width="19" height="10" />

                <rect x="0" y="44" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="47" rx="1" ry="1" width="400" height="35" />

                <rect x="0" y="88" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="92" rx="1" ry="1" width="20" height="10" />
                <rect x="385" y="92" rx="1" ry="1" width="15" height="10" />
              </vue-content-loading>
            </div>

          </div>
        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>